export const HOTELS_STATES = [
    {
        name: 'app.**',
        parent: 'root',
        url: '/',
        redirectTo: 'dashboard',
        lazyLoad: $transitions => {

            const $ocLazyLoad = $transitions.injector().get('$ocLazyLoad');

            return import('../app/app.module')
                .then(mod => $ocLazyLoad.load(mod.APP_MODULE))
                .catch(err => {

                    throw new Error(err);
                });
        }
    }
];



// WEBPACK FOOTER //
// ./src/app/app.state.js